import PageHeader from '@/components/layout/PageHeader';
import React, { useEffect, useState } from 'react';
import ajax from '@/scripts/ajax';
import dayjs from 'dayjs';
import { Button, Input, Card, Form, Typography, message, InputNumber, Select, Col, Row, Table } from 'antd';
import { getLabelFromMap, createJsonOptions } from '@/scripts/utils';
const pageKey = 'CheckList'; //页面身份
export default function CheckList() {
    const [dataSource, setData] = useState([]);
    // const [pageKey, setPageKey] = useState(pageKey);
    const [form] = Form.useForm();
    const [editingKey, setEditingKey] = useState('');

    const loading = () => {
        ajax.get('/maersk/book/check')
            .then((response) => {
                // let data = response;
                response.map((item) => {
                    if (item.is_open === 0) {
                        item.is_open = '关闭';
                    } else if (item.is_open === 1) {
                        item.is_open = '开启';
                    }
                    return item;
                });
                setData(response);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        loading();
    }, []);

    const save = async (id) => {
        try {
            const row = await form.validateFields();
            if (row.is_open === '开启') {
                row.is_open = 1;
            } else if (row.is_open === '关闭') {
                row.is_open = 0;
            }
            let params = {
                ...row,
                id: id,
            };
            if (params.is_open === undefined || params.is_open === null || params.id === '' || params.host === '' || params.port === '') {
                message.error('数据不能为空');
                return;
            } else {
                ajax.post('/maersk/book/check', params)
                    .then((response) => {
                        message.success('修改成功');
                        loading();
                    })
                    .catch((err) => {
                        console.log(err);
                    });
                setEditingKey('');
            }
        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    };

    const EditableCell = ({ editing, inputType, dataIndex, title, openTypeSelect, record, index, children, ...restProps }) => {
        let inputNode;
        if (inputType === 'number') {
            inputNode = <InputNumber />;
        } else {
            inputNode = <Input />;
        }
        if (openTypeSelect === 'select') {
            inputNode = <Select style={{ width: 100 }} options={createJsonOptions(['开启', '关闭'])} showSearch allowClear></Select>;
        }

        return (
            <td>
                {editing ? (
                    <Form.Item
                        name={dataIndex}
                        style={{
                            margin: 0,
                        }}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };

    const isEditing = (record) => record.id === editingKey;

    const edit = (record) => {
        form.setFieldsValue({
            id: record.id,
            host: record.host,
            is_open: record.is_open,
            port: record.port,
            ...record,
        });
        setEditingKey(record.id);
    };

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            // width: 80,
            sorter: (a, b) => a?.id - b?.id,
        },
        {
            title: '端口',
            dataIndex: 'port',
            // width: 180,
            editable: true,
            sorter: (a, b) => a?.port - b?.port,
        },
        {
            title: '主机号',
            dataIndex: 'host',
            // width: 120,
            editable: true,
            sorter: (a, b) => a['host'].localeCompare(b['host']),
        },
        {
            title: '是否开启',
            dataIndex: 'is_open',
            // width: 120,
            editable: true,
            sorter: (a, b) => a['is_open'].localeCompare(b['is_open']),
        },
        {
            title: '操作',
            width: 80,
            dataIndex: 'operation',
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Typography.Link
                            onClick={() => save(record.id)}
                            style={{
                                marginRight: 8,
                            }}
                        >
                            保存
                        </Typography.Link>
                        {/* <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
                            <a href="#">Cancel</a>
                        </Popconfirm> */}
                    </span>
                ) : (
                    <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
                        修改
                    </Typography.Link>
                );
            },
        },
    ];

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                openTypeSelect: col.dataIndex === 'is_open' ? 'select' : 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });

    return (
        <div className="list">
            <PageHeader title="check列表" sticky></PageHeader>
            <Form form={form} component={false}>
                <Table
                    components={{
                        body: {
                            cell: EditableCell,
                        },
                    }}
                    rowKey={(record) => record.id}
                    bordered
                    dataSource={dataSource}
                    // columns={mergedColumns}
                    columns={mergedColumns}
                    rowClassName="editable-row"
                    pagination={false}
                />
            </Form>
        </div>
    );
}
